import { render } from "./BookingDetail.vue?vue&type=template&id=78806cba&scoped=true"
import script from "./BookingDetail.vue?vue&type=script&lang=js"
export * from "./BookingDetail.vue?vue&type=script&lang=js"

import "./BookingDetail.vue?vue&type=style&index=0&id=78806cba&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78806cba"]])

export default __exports__